import React, { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import { GlobalState } from '../../../GlobalState';
import { TabTitle } from '../../../util/titleChanger'
import { toast, ToastContainer } from 'react-toastify';
import { deleteCustomer, deleteUserByNic } from '../../../action';
import { api } from '../../../util/urlConfig';
import Loading from '../../../util/Loading';

export default function CustomerDashboard() {
    TabTitle("Customer Dashboard");
    const state = useContext(GlobalState);
    const [customers] = state.customerAPI.customers;
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    //Local states
    const [rowPerPage] = state.customerAPI.rowPerPage;
    const [pageNumber, setPageNumber] = state.customerAPI.pageNumber;
    const [totalPages] = state.customerAPI.totalPages;
    const [setSearch] = state.customerAPI.search;
    const [callback, setCallback] = state.customerAPI.callback;

    useEffect(() => { }, [rowPerPage, customers, pageNumber])

    const pageNumberHandler = (data) => {
        let newPageNumber = data.selected + 1;
        setPageNumber(newPageNumber)
    }

    const searchHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);
        setSearch(e.target.value ? e.target.value : "");
    }

    const deleteCustomerHandler = (id, nic) => {
        deleteCustomer(id, signInUser.id, res => {
            if (res.status === 200) {
                deleteUserByNic(nic);
                toast.success(res.data);
                setCallback(!callback)
            } else {
                toast.error(res.data);
                setCallback(!callback)
            }
        })
    }
    return (
        <div className='form-container'>
            <div className="table">
                <div className="table_header">
                    <p>Customer Details</p>
                    <div>
                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Search customer here...'
                            onChange={(e) => searchHandler(e)}
                        />
                        <Link to="/customer-form"><button className="add_new">+ Add New</button></Link>
                    </div>
                </div>

                {customers.count === 0 ? <div className="loading-page-container"><Loading /></div>
                    : <div className="table_section">
                        <table>
                            <thead>
                                <tr>
                                    <th>Avatar</th>
                                    <th>Customer Code</th>
                                    <th>Full Name</th>
                                    <th>NIC</th>
                                    <th>Contact No</th>
                                    <th>Email</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    customers.count > 0 ? customers.data.map(customer => (
                                        <tr key={customer.id}>
                                            <td><img src={customer.upload_image ? api + "/" + customer.upload_image.image_url : '/img/dummy_avatar.png'} alt="avatar" /></td>
                                            <td>{customer.customer_code}</td>
                                            <td>{customer.first_name + " " + customer.last_name}</td>
                                            <td>{customer.nic}</td>
                                            <td>{customer.contact_no}</td>
                                            <td>{customer.email}</td>
                                            <td>
                                                <Link to={`/customer-form/${customer.id}`}><button><i className="uil uil-edit"></i></button></Link>
                                                <Link to={`/customer-view/${customer.id}`}><button><i className="uil uil-eye"></i></button></Link>
                                                <button onClick={() => deleteCustomerHandler(customer.id, customer.nic)}><i className="uil uil-trash-alt"></i></button>
                                            </td>
                                        </tr>
                                    ))
                                        : <tr>
                                            <td colSpan="7">Can not found any customers.</td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={pageNumberHandler}
                    marginPagesDisplayed={2}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageLinkClassName='page-num'
                    previousLinkClassName='page-num'
                    nextLinkClassName='page-num'
                    activeLinkClassName='active-num'
                />
            </div>
            <ToastContainer />
        </div>
    )
}
